import React from "react";
import { SortByProps } from "@usereactify/search";

export type SortByDesktopProps = React.ComponentProps<
    NonNullable<SortByProps["render"]>
> & {
    isOpen: boolean;
    handleOptionSelect: (handle: string) => void;
    selectedOption: string;
};

export const SortByDesktop: React.FC<SortByDesktopProps> = ({
    isOpen,
    handleOptionSelect,
    sortOptions
}) => {
    return (
        <div className="relative block">
            {isOpen && (
                <div className="dropdown-content">
                    {sortOptions.map((sortOption) => (
                        <p
                            key={sortOption.handle}
                            className="rs__sortby__option"
                            onClick={() => handleOptionSelect(sortOption.handle)}
                        >
                            {sortOption.name}
                        </p>
                    ))}
                </div>
            )}
        </div>
    );
};
